const getUserAgent = (userAgent = navigator?.userAgent) => {
    // Windows Phone
    if (/windows phone/i.test(userAgent)) {
        return 'Windows';
    }

    // Check if the user agent contains "Android" to identify Android devices
    if (/android/i.test(userAgent)) {
        return 'Android';
    }

    // Check if the user agent contains "iPhone" or "iPad" to identify iOS devices
    if (/iPad|iPhone|iPod/i.test(userAgent)) {
        return 'iOS';
    }

    return userAgent;
};

const isMobile = (userAgent = navigator?.userAgent) => {
    const agent = getUserAgent(userAgent);

    if (/^iOS|Android|Windows$/i.test(agent)) return agent;
    return false;
};

const isPWA = (window) => {
    const mqStandAlone = '(display-mode: standalone)';
    return ('standalone' in window.navigator && window.navigator.standalone) || window.matchMedia(mqStandAlone).matches;
};

const isiOSPWA = (window) => isPWA(window) && /iPad|iPhone|iPod|Macintosh; Intel.*Safari/i.test(navigator?.userAgent);

const hasPWA = (window) => window.localStorage.getItem('APP_INSTALLED') === 'true';

const isPWAInstalled = (window) => {
    const inLocalStorage = hasPWA(window);
    const runningPWA = isPWA(window);

    // Set localstorage for hasPWA if not already set
    if (!inLocalStorage && runningPWA) {
        window.localStorage.setItem('APP_INSTALLED', 'true');
    }

    return inLocalStorage || runningPWA;
};

// export const shouldLaunchPWA = () => hasPWA() === 'true' && !isPWA() && isMobile();

export default { getUserAgent, isMobile, isPWA, hasPWA, isPWAInstalled, isiOSPWA };
